import { Type } from "class-transformer";
import { Theme } from "../theme/theme.model";
import { FormGroupInstance } from "./form-group-instance.model";

export class FormGroupCompany extends Theme {
  externalId: string;
  name: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  postCode: string;
  country: string;
  postalAddress: string;
  postalAddressCity: string;
  postalAddressPostCode: string;
  postalAddressState: string;
  clientCategory: string;
  orgId: string;
  rurality: string;
  @Type(() => require("./form-group-instance.model").FormGroupInstance)
  formGroupInstance: FormGroupInstance;
  formGroupInstanceId: number;
  @Type(() => Boolean)
  isPrimary: boolean;

  public get fullPremiseAddress(): string {
    return `${!!this.address ? this.address + ", " : ""}${
      !!this.address2 ? this.address2 + ", " : ""
    }${!!this.city ? this.city + ", " : ""}${!!this.state ? this.state + ", " : ""}${
      !!this.postCode ? this.postCode + ", " : ""
    }${!!this.country ? this.country : ""}`.replace(/,\s*$/, "");
  }
}
